import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { App } from './app/App'
import i18n from './i18n'
import { isLangCode, DEFAULT_LANG } from '@shared/i18n/languages'
import '@styles/globals.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

// Prerendered routes ship with markup (and text) already inside #root, in
// whichever language the URL asked for. i18next must settle on that same
// language before the first client render, or hydrateRoot diffs against
// text that doesn't match yet and re-renders with a visible flash.
const urlLang = window.location.pathname.split('/')[1]
const lang = isLangCode(urlLang) ? urlLang : DEFAULT_LANG

void i18n.changeLanguage(lang).then(() => {
  const app = (
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  )

  // Any route the prerender script didn't cover (or the dev server, where
  // #root starts empty) falls back to a plain client-side render.
  if (root.hasChildNodes()) {
    hydrateRoot(root, app)
  } else {
    createRoot(root).render(app)
  }
})
